exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-27a0a578] .el-tabs__header{margin:0}[data-v-27a0a578] .el-tabs__item{line-height:50px;height:50px;vertical-align:top}.el-tabs-border[data-v-27a0a578] .el-tabs__nav-wrap:after{background-color:transparent}span[data-v-27a0a578]{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27a0a578","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Tabs/index.vue
// module id = 600
// module chunks = 0